import {useCallback, useEffect, useState} from 'react';
import {
  useDownloadWishesPdf
} from "@common/auth/ui/account-settings/wish-list-panel/download-wishes-pdf";
import {useAuth} from "@common/auth/use-auth";
import {Button} from "@common/ui/buttons/button";
import {Trans} from "@common/i18n/trans";

const SECTIONS = [
  {id: 'emergency', label: 'Emergency contacts'},
  {id: 'physical', label: 'Physical documents'},
  {id: 'health', label: 'Health'},
  {id: 'digital', label: 'Digital'},
  {id: 'legal', label: 'Legal'},
  {id: 'financial', label: 'Financial'},
  {id: 'funeral', label: 'Funeral'},
  {id: 'anything', label: 'Other'},
] as const;

export function ScrollSpyNav() {
  const [active, setActive] = useState<string>(SECTIONS[0].id);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      {rootMargin: '-40% 0px -55% 0px', threshold: [0, 0.25, 0.5, 0.75, 1]}
    );

    SECTIONS.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const onClick = useCallback((e: React.MouseEvent, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({behavior: 'smooth', block: 'start'});
  }, []);

  return (
    <div className="sticky top-0 z-50">
      <nav className="bg-background/80 backdrop-blur border-b">
        <div className="max-w-5xl mx-auto py-10 flex items-center justify-between min-w-0">
          <ul className="min-w-0 flex flex-wrap gap-3 sm:gap-6">
            {SECTIONS.map(s => (
              <li key={s.id}>
                <a
                  href={`#${s.id}`}
                  onClick={e => onClick(e, s.id)}
                  className={`px-10 py-6 rounded-full text-sm transition ${
                    active === s.id ? 'bg-primary text-white' : 'hover:bg-muted'
                  }`}
                >
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </div>
  );
}
